import React from 'react'
import TransitEditor from '../../features/declaration/form/transit/components/TransitEditor'
import useClearQueryCache from '../../features/declaration/form/api/useClearQueryCache'
import useDeclarationSessionKey from '../../features/declaration/form/components/useDeclarationSessionKey'
import useAuthGuard from '../../app/guards/useAuthGuard'
import { NctsErrorProvider } from '../../features/declaration/form/contexts/NctsErrorContext'
import { ConfirmProvider } from '../../shared/components/confirm/ConfirmProvider'
import { DeclarationEditorContextProvider } from '../../features/declaration/form/contexts/DeclarationEditorContext'
import { CalculatorModalProvider } from '../../features/declaration/form/components/calculator/CalculatorModalContext'

export function TransitEditorSession() {
  useClearQueryCache()

  return (
    <ConfirmProvider>
      <DeclarationEditorContextProvider isEns={false}>
        <NctsErrorProvider>
          <CalculatorModalProvider>
            <TransitEditor />
          </CalculatorModalProvider>
        </NctsErrorProvider>
      </DeclarationEditorContextProvider>
    </ConfirmProvider>
  )
}

function TransitEditorPage() {
  useAuthGuard()
  const sessionKey = useDeclarationSessionKey()

  return <TransitEditorSession key={sessionKey} />
}

export default TransitEditorPage
